import { useMemo, useState } from "react";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Input } from "./ui/input";
import { sendMagicLink, signInGoogle } from "../sign-ins";
import { Label } from "./ui/label";
import { useSession } from "../auth-client";

export function SendMail({ onEmailSent }: { onEmailSent: () => void }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [sending, setSending] = useState(false);

  function changeEmail(event: React.ChangeEvent<HTMLInputElement>) {
    setEmail(event.target.value);
  }
  function changeName(event: React.ChangeEvent<HTMLInputElement>) {
    setName(event.target.value);
  }

  const buttonDisabled = useMemo(
    () => !email || !name || !email.includes("@") || !email.includes(".") || name.length < 2,
    [email, name]
  );

  async function onMagicLinkBtn() {
    setSending(true);
    await sendMagicLink(name, email);
    setSending(false);
    onEmailSent();
  }

  return (
    <>
      {sending ? (
        <div className="text-center py-4">Email wird versendet...</div>
      ) : (
        <div className="grid w-full items-center gap-3">
          <Label htmlFor="name">Vorname</Label>
          <Input type="text" id="name" placeholder="Vorname" value={name} onChange={changeName} />
          <Label htmlFor="email">Email</Label>
          <Input type="email" id="email" placeholder="Email" value={email} onChange={changeEmail} />
          <Button onClick={onMagicLinkBtn} className="mt-2" disabled={buttonDisabled}>
            Senden
          </Button>
        </div>
      )}
    </>
  );
}

export function EmailSentDialog({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="mb-4">Sende Email Link</DialogTitle>
          <div>Email wurde versendet. Bitte prüfe dein Email Postfach.</div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}

export function AuthProvider(props: { children: React.ReactNode }) {
  const session = useSession();
  const [showConfirmation, setShowConfirmation] = useState(false);

  if (session.isPending) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <div className="animate-spin h-8 w-8 border-4 border-zinc-300 border-t-zinc-600 rounded-full mx-auto mb-4"></div>
          <p className="text-zinc-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!session.data) {
    return (
      <>
        <div className="mt-40 grid justify-center">
          <Card className="w-[280px]">
            <CardHeader className="grid justify-center">
              <CardTitle>John Doe - Internal</CardTitle>
            </CardHeader>
            <CardContent className="grid justify-center">
              <a rel="noreferrer">
                <Button onClick={signInGoogle}>Sign in with Google</Button>
              </a>
              <Dialog>
                <DialogTrigger className="items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-950 disabled:opacity-50 disabled:pointer-events-none ring-offset-white hover:text-zinc-950/80 h-10 py-2 px-4 block">
                  or use email link
                </DialogTrigger>
                <DialogContent>
                  <DialogHeader>
                    <DialogTitle className="mb-4">Sende Email Link</DialogTitle>
                    <SendMail onEmailSent={() => setShowConfirmation(true)} />
                  </DialogHeader>
                </DialogContent>
              </Dialog>
            </CardContent>
          </Card>
        </div>

        <EmailSentDialog isOpen={showConfirmation} onClose={() => setShowConfirmation(false)} />
      </>
    );
  }
  return <>{props.children}</>;
}
